import { render, staticRenderFns } from "./HomeCopyright.vue?vue&type=template&id=ce80d72a&scoped=true&"
import script from "./HomeCopyright.vue?vue&type=script&lang=js&"
export * from "./HomeCopyright.vue?vue&type=script&lang=js&"
import style0 from "./HomeCopyright.vue?vue&type=style&index=0&id=ce80d72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce80d72a",
  null
  
)

export default component.exports